var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCartBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 85 88",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.000000, -6.000000) translate(10.000000, 8.000000)",
    stroke: "currentColor",
    strokeWidth: 4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.76,0.8 L6.76,0.8 C10.3411958,0.986378344 13.2862525,3.68811122 13.78,7.24 L21.38,51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,17 L79.6,17 C79.9258963,17.0027134 80.230875,17.1609971 80.4206788,17.4259316 C80.6104826,17.6908661 80.6622568,18.03055 80.56,18.34 L74.14,45 C72.7236859,48.9969583 68.9404699,51.6660493 64.7,51.6600103 L21.78,51.6600103"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.62,
    cy: 75.6,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.2,
    cy: 75.6,
    r: 7.48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartBlack);
export default __webpack_public_path__ + "static/media/Shopping Cart Black.258edaee392f89727f4453edd3642768.svg";
export { ForwardRef as ReactComponent };